import { defineComponent } from 'vue';
export default defineComponent({
    name: 'PermalinkList',
    props: {
        taxonomy: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        terms: {
            type: Array,
            required: true,
        },
        selected: {
            type: String,
            default: null,
        },
        baseUrl: {
            type: String,
            required: true,
        },
        fullOpen: {
            type: Boolean,
            default: false,
        },
        depth: {
            type: Number,
            default: 1,
        },
        maxDepth: {
            type: Number,
            default: null,
        },
    },
    data() {
        const openMap = new Map();
        for (const t of this.terms) {
            openMap.set(t.id, this.fullOpen || t.id === this.selected);
        }
        return {
            openMap,
        };
    },
});
